import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import Text from '../text/Text';
import Select from '../form/selects/Select';
import months from './../../static-data/months.json'
import moment from 'moment';
import InputCalendar from '../form/inputs/inputCalendar';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import MomentUtils from '@date-io/moment';
import "moment/locale/pl";
import ImgRightCol from './../../images/test.jpg';
import revenuesScore from './../../static-data/revenue-score.json'
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import FinancialDataFiles from './../../components/financial-data-files/FinancialDataFiles';

const CheckAndLoss = ( props ) => {
    let [ isOpenFirst, setIsOpenFirst ]       = useState([]);   
    const dispatch                          = useDispatch()
    let maxThreshold                        = useSelector(state => state.maxThreshold);
    let productPrice                        = useSelector(state => state.productPrice); 
    let checkAndLossAmortizationOld         = useSelector(state => state.checkAndLossAmortizationOld);
    let profitFromSalesOld                  = useSelector(state => state.profitFromSalesOld);
    let checkAndLossFrom                    = useSelector(state => state.checkAndLossFrom);
    let checkAndLossTo                      = useSelector(state => state.checkAndLossTo);
    let checkAndLossAmortization            = useSelector(state => state.checkAndLossAmortization);
    let profitFromSales                     = useSelector(state => state.profitFromSales);
    let balanceFixedAssets                  = useSelector(state => state.balanceFixedAssets);
    let balanceFixedAssetsOld               = useSelector(state => state.balanceFixedAssetsOld);
    let balanceTotalEquity                  = useSelector(state => state.balanceTotalEquity);
    let balanceTotalEquityOld               = useSelector(state => state.balanceTotalEquityOld);
    let balanceBusinesslikeAndDurable       = useSelector(state => state.balanceBusinesslikeAndDurable);
    let balanceBusinesslikeAndDurableOld    = useSelector(state => state.balanceBusinesslikeAndDurableOld);
    let balanceCoreCapital                  = useSelector(state => state.balanceCoreCapital);
    let balanceCoreCapitalOld               = useSelector(state => state.balanceCoreCapitalOld);
    let balanceAssets                       = useSelector(state => state.balanceAssets);
    let balanceAssetsOld                    = useSelector(state => state.balanceAssetsOld);
    let balanceLiabilitiesAndProvisions     = useSelector(state => state.balanceLiabilitiesAndProvisions);
    let balanceLiabilitiesAndProvisionsOld  = useSelector(state => state.balanceLiabilitiesAndProvisionsOld);
    let balanceWrestling                    = useSelector(state => state.balanceWrestling);
    let balanceWrestlingOld                 = useSelector(state => state.balanceWrestlingOld);
    let balanceLongtermLiabilities          = useSelector(state => state.balanceLongtermLiabilities);
    let balanceLongtermLiabilitiesOld       = useSelector(state => state.balanceLongtermLiabilitiesOld);
    let balanceShorttermReceivables         = useSelector(state => state.balanceShorttermReceivables);
    let balanceShorttermReceivablesOld      = useSelector(state => state.balanceShorttermReceivablesOld);
    let balanceCurrentLiabilities           = useSelector(state => state.balanceCurrentLiabilities);
    let balanceCurrentLiabilitiesOld        = useSelector(state => state.balanceCurrentLiabilitiesOld);
    let balanceCash                         = useSelector(state => state.balanceCash);
    let balanceCashOld                      = useSelector(state => state.balanceCashOld);
    let balanceSumOfAssetsLiabilities       = useSelector(state => state.balanceSumOfAssetsLiabilities);
    let balanceSumOfAssetsLiabilitiesOld    = useSelector(state => state.balanceSumOfAssetsLiabilitiesOld);
    let balanceFrom                         = useSelector(state => state.balanceFrom);
    let balanceTo                           = useSelector(state => state.balanceTo);
    let receivablesObligationsDeliveriesServicesDate     = useSelector(state => state.receivablesObligationsDeliveriesServicesDate)
    let balanceDate                         = useSelector(state => state.balanceDate);
    let balanceObligations                  = useSelector(state => state.balanceObligations);
    let balanceReceivables                  = useSelector(state => state.balanceReceivables);
    let checkAndLossAmortizationTypeOldTwo  = useSelector(state => state.checkAndLossAmortizationTypeOldTwo);
    let checkAndLossAmortizationTypeOld     = useSelector(state => state.checkAndLossAmortizationTypeOld);
    let expiredStatus                       = useSelector(state => state.expiredStatus);

    const materialTheme = createMuiTheme({
        overrides: {
            MuiPickersCalendarHeader: {
                switchHeader: {
                    color: '#74726b',
                },
              },
          MuiPickersDay: {
                day: {
                    color: '#74726b',
                },
            },
        }
    });

    const updateCalendar = (index, status) => {
        let newRes = [];
        if(status) {
            if(!isOpenFirst.includes(index)) {
                setIsOpenFirst([...isOpenFirst, index]);
            }
        }else{
            if(isOpenFirst.includes(index)) {
                newRes = isOpenFirst.filter(first => first == index ? null : first)
                setIsOpenFirst(newRes);
            }
        }
    }

    let getFirstYear = () => {
        let getMonth = moment().month();
        let getActualYear = moment().add(-1, 'years').year();

        if ( getMonth < 1 ) {
            getActualYear = moment().add(-2, 'years').year();
        }
        return getActualYear;
    }

    let getYear = count => {
        let getMonth = moment().month();
        let getActualYear = moment().year();

        if ( getMonth < 1 ) {
            getActualYear = moment().add(count, 'years').year();
        }
        return getActualYear;
    }

    let getYearTwo = count => {
        let getMonth = moment().month();
        let getActualYear = moment().year();
        getActualYear = moment().subtract(2, 'years').year();

        return getActualYear;
    }

    let getLastMonth = () => {
        return moment().add(-1, 'months').month();
    }

    return (
        <div className="check-and-loss">
            <Text class="small-margin" text="Uzupełnij poniżej wymagane dane finansowe lub wczytaj (za pomocą belki poniżej) pliki z dokumentami obowiązującymi dla Twojej firmy (Rachunek zysków i strat / Bilans lub Księga przychodów i rozchodów / PIT" />
            <Heading title="RACHUNEK ZYSKÓW I STRAT (KWOTA W TYS. ZŁ)" medium smallMargin />
            {/* <div className="img-col">
                <img src={ImgRightCol} alt="" />
            </div> */}
            <div className="row">
                <Heading title={ "Dane za rok " + getFirstYear()} small />
                
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "checkAndLossAmortizationOld" }
                                id="checkAndLossAmortizationOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'CHECK_AND_LOSS_AMORTIZATION_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Amortyzacja" }
                                val={ checkAndLossAmortizationOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Select
                            id="checkAndLossAmortizationTypeOld"
                            data={ revenuesScore }  
                            forceValidate={ props.forceValidate } 
                            placehold="Wynik ze sprzedaży w zł" 
                            val={ checkAndLossAmortizationTypeOld }
                            required={ false }
                            setFunction={ val => dispatch({ type: 'CHECK_AND_LOSS_AMORTIZATION_TYPE_OLD_CHANGE', value: val }) } />
                    </div>
                    <div className="col">
                        <Input  name={ "profitFromSalesOld" }
                                id="profitFromSalesOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'PROFIT_FROM_SALES_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota zysku / straty w zł" }
                                val={ profitFromSalesOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
            </div>

            <div className="row">
                <Heading title={ "Dane za rok " + getYear(-1) } small />
                <div className="inputs">
                    <div className="col">
                        <Select
                            id="from"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Od" 
                            required={ false }
                            disabledIndex={ getLastMonth() }
                            val={ checkAndLossFrom }
                            setFunction={ val => dispatch({ type: 'CHECK_AND_LOSS_FROM_CHANGE', value: val }) }  />
                    </div>
                    <div className="col">
                        <Select
                            id="to"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Do" 
                            required={ false }
                            val={ checkAndLossTo }
                            disabledIndex={ getLastMonth() }
                            setFunction={ val => dispatch({ type: 'CHECK_AND_LOSS_TO_CHANGE', value: val }) }   />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "checkAndLossAmortization" }
                                id="checkAndLossAmortization"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'CHECK_AND_LOSS_AMORTIZATION_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Amortyzacja" }
                                val={ checkAndLossAmortization }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Select
                            id="checkAndLossAmortizationTypeOldTwo"
                            data={ revenuesScore }  
                            forceValidate={ props.forceValidate } 
                            placehold="Wynik ze sprzedaży w zł" 
                            val={ checkAndLossAmortizationTypeOldTwo }
                            required={ false }
                            setFunction={ val => dispatch({ type: 'CHECK_AND_LOSS_AMORTIZATION_TYPE_OLD_TWO_CHANGE', value: val }) } />
                    </div>
                    <div className="col">
                        <Input  name={ "profitFromSales" }
                                id="profitFromSales"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'PROFIT_FROM_SALES_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota zysku / straty w zł" }
                                val={ profitFromSales }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
            </div>
            <Heading title="Bilans (KWOTA W TYS. ZŁ)" medium class="marginTop" />
            <div className="row">
                <Heading title={ "Dane za rok " + getFirstYear()} small />
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceFixedAssetsOld" }
                                id="balanceFixedAssetsOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_FIXED_ASSETS_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Aktywa trwałe" }
                                boldPlacehold
                                val={ balanceFixedAssetsOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceTotalEquityOld" }
                                id="balanceTotalEquityOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_TOTAL_EQUITY_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kapitał własny łącznie" }
                                boldPlacehold
                                val={ balanceTotalEquityOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceBusinesslikeAndDurableOld" }
                                id="balanceBusinesslikeAndDurableOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_BUSINESSLIKE_AND_DURABLE_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Rzeczowy majątek trwały" }
                                val={ balanceBusinesslikeAndDurableOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceCoreCapitalOld" }
                                id="balanceCoreCapitalOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CORE_CAPITAL_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kapitał podstawowy" }
                                val={ balanceCoreCapitalOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceAssetsOld" }
                                id="balanceAssetsOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_ASSETS_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Aktywa obrotowe" }
                                boldPlacehold
                                val={ balanceAssetsOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceLiabilitiesAndProvisionsOld" }
                                id="balanceLiabilitiesAndProvisionsOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_LIABILITIES_AND_PROVISIONS_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania i rezerwy" }
                                boldPlacehold
                                val={ balanceLiabilitiesAndProvisionsOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceWrestlingOld" }
                                id="balanceWrestlingOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_WRESTLING_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zapasy" }
                                val={ balanceWrestlingOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceLongtermLiabilitiesOld" }
                                id="balanceLongtermLiabilitiesOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_LONGTERM_LIABILITIES_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania długoterminowe" }
                                val={ balanceLongtermLiabilitiesOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceShorttermReceivablesOld" }
                                id="balanceShorttermReceivablesOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_SHORTTERM_RECEIVABLES_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Należności krótkoterminowe" }
                                val={ balanceShorttermReceivablesOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceCurrentLiabilitiesOld" }
                                id="balanceCurrentLiabilitiesOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CURRENT_LIABILITIES_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania krótkoterminowe" }
                                val={ balanceCurrentLiabilitiesOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceCashOld" }
                                id="balanceCashOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CASH_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Środki pieniężne" }
                                val={ balanceCashOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceSumOfAssetsLiabilitiesOld" }
                                id="balanceSumOfAssetsLiabilitiesOld"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_SUM_OF_ASSETS_LIABILITIES_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Suma aktywa/pasywa" }
                                boldPlacehold
                                val={ balanceSumOfAssetsLiabilitiesOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
            </div>
            <div className="row">
                <Heading title={ "Dane za rok " + getYear(-1) } small />
                <div className="inputs">
                    <div className="col">
                        <Select
                            id="balanceFrom"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Od" 
                            required={ false }
                            disabledIndex={ getLastMonth() }
                            val={ balanceFrom }
                            setFunction={ val => dispatch({ type: 'BALANCE_FROM_CHANGE', value: val }) }  />
                    </div>
                    <div className="col">
                        <Select
                            id="balanceTo"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Do" 
                            required={ false }
                            val={ balanceTo }
                            disabledIndex={ getLastMonth() }
                            setFunction={ val => dispatch({ type: 'BALANCE_TO_CHANGE', value: val }) }   />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceFixedAssets" }
                                id="balanceFixedAssets"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_FIXED_ASSETS_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Aktywa trwałe" }
                                boldPlacehold
                                val={ balanceFixedAssets }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceTotalEquity" }
                                id="balanceTotalEquity"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_TOTAL_EQUITY_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kapitał własny łącznie" }
                                boldPlacehold
                                val={ balanceTotalEquity }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceBusinesslikeAndDurable" }
                                id="balanceBusinesslikeAndDurable"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_BUSINESSLIKE_AND_DURABLE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Rzeczowy majątek trwały" }
                                val={ balanceBusinesslikeAndDurable }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceCoreCapital" }
                                id="balanceCoreCapital"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CORE_CAPITAL_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kapitał podstawowy" }
                                val={ balanceCoreCapital }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceAssets" }
                                id="balanceAssets"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_ASSETS_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Aktywa obrotowe" }
                                boldPlacehold
                                val={ balanceAssets }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceLiabilitiesAndProvisions" }
                                id="balanceLiabilitiesAndProvisions"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_LIABILITIES_AND_PROVISIONS_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania i rezerwy" }
                                boldPlacehold
                                val={ balanceLiabilitiesAndProvisions }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceWrestling" }
                                id="balanceWrestling"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_WRESTLING_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zapasy" }
                                val={ balanceWrestling }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceLongtermLiabilities" }
                                id="balanceLongtermLiabilities"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_LONGTERM_LIABILITIES_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania długoterminowe" }
                                val={ balanceLongtermLiabilities }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceShorttermReceivables" }
                                id="balanceShorttermReceivables"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_SHORTTERM_RECEIVABLES_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Należności krótkoterminowe" }
                                val={ balanceShorttermReceivables }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceCurrentLiabilities" }
                                id="balanceCurrentLiabilities"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CURRENT_LIABILITIES_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Zobowiązania krótkoterminowe" }
                                val={ balanceCurrentLiabilities }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "balanceCash" }
                                id="balanceCash"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_CASH_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Środki pieniężne" }
                                val={ balanceCash }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />

                    </div>
                    <div className="col">
                        <Input  name={ "balanceSumOfAssetsLiabilities" }
                                id="balanceSumOfAssetsLiabilities"
                                required={ false }
                                setFunction={ val =>  dispatch({ type: 'BALANCE_SUM_OF_ASSETS_LIABILITIES_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Suma aktywa/pasywa" }
                                boldPlacehold
                                val={ balanceSumOfAssetsLiabilities }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/} 
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } />
                    </div>
                </div>
            </div>
            <div className="row">
                <FinancialDataFiles forceValidate={props.forceValidate} />
            </div>
            <div className="row margin-top">
                <Heading title="Zobowiązania i należności z tytułu dostaw i usług" medium class="marginTop" />
                <Heading title="Posiadam przeterminowane" small />
                <div className="inputs">
                    <div className="col col-flex">
                        <div className="row">
                            <CheckboxRadio  required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'EXPIRED_STATUS_CHANGE', value: val })}
                                            otherForceValidate={ props.forceValidate }
                                            val={ expiredStatus}
                                            text="Tak" />

                            <CheckboxRadio  required={ true } 
                                            setFunction={ (val) =>  dispatch({ type: 'EXPIRED_STATUS_CHANGE', value: val })}
                                            otherForceValidate={ props.forceValidate }
                                            text="Nie" 
                                            val={ expiredStatus } />
                        </div>
                    </div>
                </div>
                {expiredStatus == "Tak" &&
                    <div className="inputs">
                        <div className="col">
                        <InputCalendar  name={"balanceDate"}
                                    id={"balanceDate"}
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'BALANCE_DATE_CHANGE', value: val }) }
                                    type="text"
                                    // placehold={ "Stan na dzień" }
                                    placehold={ "Zobow./należn. - stan na dzień" }
                                    val={ balanceDate }
                                    size="xxl" 
                                    calendar={ true }
                                    regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                    allowChars={/^[0-9-]{0,10}$/}
                                    minChar={ 1 } 
                                    maxDate={new Date()}
                                    openCalendar={ () => updateCalendar(0, true) }
                                    forceValidate={ props.forceValidate } />
                            <ThemeProvider theme={materialTheme}>
                                <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                                    <KeyboardDatePicker
                                        cancelLabel="Anuluj"
                                        value={ balanceDate }
                                        placeholder="2018-10-10"
                                        onChange={date =>  dispatch({ type: 'BALANCE_DATE_CHANGE', value: moment(date).format("YYYY-MM-DD") }) }
                                        maxDate={new Date()}
                                        format="YYYY-MM-DD"
                                        open={isOpenFirst.includes(0)}
                                        onOpen={() => updateCalendar(0, true)}
                                        onClose={() => updateCalendar(0, false)}
                                    />
                                </MuiPickersUtilsProvider>
                            </ThemeProvider>
                        </div>
                        <div className="col">
                            <Input  name={"balanceObligations"}
                                    id="balanceObligations"
                                    required={ true }
                                    setFunction={ val =>  dispatch({ type: 'BALANCE_OBLIGATIONS_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Zobowiązania przeterminowane z tyt. dostaw i usług" }
                                    val={ balanceObligations }
                                    size="xxl" 
                                    smallerText
                                    formatPrice={ true }
                                    regExp={/^[0-9\,\.\s]+$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate } />
                        </div>
                        <div className="col">
                            <Input  name={"balanceReceivables"}
                                    id="balanceReceivables"
                                    required={ true }
                                    setFunction={ val =>  dispatch({ type: 'BALANCE_RECEIVABLES_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Należności przeterminowane z tyt. dostaw i usług" }
                                    val={ balanceReceivables }
                                    size="xxl" 
                                    smallerText
                                    formatPrice={ true }
                                    regExp={/^[0-9\,\.\s]+$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate } />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CheckAndLoss;